import { BigDecimal, Match } from 'effect';

import {
  currencies,
  Currency,
  CurrencySchema,
  type CurrencyT,
  getCurrencyFormatConfig,
  getCurrencySymbol,
} from '@vs-shop/domain/price';

import { getDefaultChannel } from './channel';
import { getChannelProfile } from './channelProfile';

// Currency vocabulary and format config moved to `@vs-shop/domain/price`
// (Stage 2 MR-B, ENGINE_MOVE.md §3; C7 T10). This module keeps the
// env-coupled selection reader plus the step helper, and re-exports the
// vocabulary and the format config. Which currency a channel uses is a
// tenant fact and lives in `channelProfile`.
export {
  currencies,
  Currency,
  CurrencySchema,
  type CurrencyT,
  getCurrencyFormatConfig,
  getCurrencySymbol,
};

export const getDefaultCurrency = (): CurrencyT => getChannelProfile(getDefaultChannel()).currency;

/**
 * Get the step value for range filter inputs based on currency
 * CZK: step = 1 (whole numbers only)
 * EUR: step = 0.01 (cents precision)
 */
export const getCurrencyStep = (currency: CurrencyT): BigDecimal.BigDecimal => {
  return Match.value(currency).pipe(
    Match.when(Currency.CZK, () => BigDecimal.make(1n, 0)),
    Match.when(Currency.EUR, () => BigDecimal.make(1n, 2)),
    Match.exhaustive
  );
};
